import React, { useRef, useState, useContext, useEffect } from 'react';
import './Registration.css';
import axios from 'axios';
import { NavLink, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { FaFileAlt } from 'react-icons/fa';
import { ConfigContext } from '../../Context/ConfigContext';
import Select from "react-select"
import { BusinessBrandsRegion, BusinessCities } from '../../Utils/Cities';
import Config from '../../appConfig';


const Registration = () => {
    const { apiB2BURL } = useContext(ConfigContext);
    const navigate = useNavigate();

    const [step, setStep] = useState(1);

    const [documents, setDocuments] = useState([
        { document_name: 'Trade License', document_path: '' },
        { document_name: 'TRN', document_path: '' },
        { document_name: 'Emirates ID', document_path: '' },
        { document_name: 'Passport', document_path: '' }
    ]);

    const [business_brand_region, setBusinessBrandRegion] = useState([]);


    const [state, setState] = useState({
        ownerName: "",
        businessName: "",
        email: "",
        phoneNumber: "",
        creditExpiryDate: "",
        creditAmount: "",
        business_type: "0",
        business_city: "",
        business_area: ""
    })

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        try {
            if (!documents || documents.length !== 4) {
                Swal.fire({
                    icon: 'error',
                    title: 'Documents Required',
                    text: "All documents listed are required"
                });
                return false;
            }
            // Show loading
            Swal.fire({
                title: 'Submitting Registration',
                text: 'Please wait...',
                allowOutsideClick: false,
                didOpen: () => {
                    Swal.showLoading();
                }
            });

            // Prepare form data with both business details and documents
            const formData = new FormData();

            // Add business details
            formData.append('owner_name', state.ownerName);
            formData.append('business_name', state.businessName);
            formData.append('business_email', state.email);
            formData.append('business_phone', state.phoneNumber);
            formData.append('business_type', state.business_type);
            formData.append('business_city', state.business_city);
            formData.append("business_brand_region", business_brand_region.join(','));
            formData.append("business_area", state.business_area);

            // Add documents
            documents.forEach((doc, index) => {
                formData.append('document_names[]', doc.document_name);
                formData.append('document_files[]', doc.document_path);
            });

            // Single API call with all data
            const response = await axios.post(`${apiB2BURL}/Customer/Users/RegisterBusiness`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.data.success) {
                // Show success message
                await Swal.fire({
                    icon: 'success',
                    title: 'Registration Successful',
                    text: 'Your business registration has been submitted successfully. We will review and get back to you within two working days.',
                    confirmButtonText: 'Go to Login'
                });

                // Redirect to login
                navigate('/login');
            } else {
                await Swal.fire({
                    icon: 'error',
                    title: 'Invalid',
                    text: response.data.message,
                    confirmButtonText: 'Ok'
                });
                // throw new Error(response.data.message || 'Registration failed');
            }
        } catch (error) {
            console.error('Registration error:', error);
            Swal.fire({
                icon: 'error',
                title: 'Registration Failed',
                text: error.response?.data?.message || 'Something went wrong. Please try again.'
            });
        }
    };

    const [showDiscountComponents, setShowDiscountComponents] = useState(false);


    useEffect(() => {
        const loadDiscountComponents = () => {
            setShowDiscountComponents(true);
        };

        if ("requestIdleCallback" in window) {
            const idleId = window.requestIdleCallback(loadDiscountComponents, { timeout: 1000 });
            return () => window.cancelIdleCallback(idleId);
        }

        const timeoutId = setTimeout(loadDiscountComponents, 100);
        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <div className="registration-page">
            {
                showDiscountComponents &&
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="bg-video"
                >
                    {
                        Config.country === "uae" ?
                            <source
                                src="/assets/images/videos/login_page.mp4"
                                type="video/mp4"
                            />
                            : Config.country === "ksa" ?
                                <source
                                    src="/assets/images/videos/ksa_login_page.mp4"
                                    type="video/mp4"
                                />
                                : null
                    }
                </video>
            }

            <div className="login-overlay">
                <div className="row">
                    <div className="col-md-12 d-flex align-items-center justify-content-center">
                        <div className="form-wrapper" style={{ marginTop: "200px" }}>
                            <div className="tab-header">
                                <div className={`tab ${step === 1 ? 'active' : ''}`} onClick={() => setStep(1)}>Company Details</div>
                                <div className={`tab ${step === 2 ? 'active' : ''}`} onClick={() => setStep(2)}>Company Documents</div>
                            </div>


                            <div className="">
                                {step === 1 && (
                                    <div className="form-step">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="login-email" style={{ display: 'flex', alignItems: 'center', gap: 6, position: 'relative' }}>
                                                        Name
                                                        <span className="required"> *</span>
                                                        <span
                                                            style={{
                                                                marginLeft: 4,
                                                                color: '#a6a6a6',
                                                                cursor: 'pointer',
                                                                fontSize: 16,
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                position: 'relative'
                                                            }}
                                                            tabIndex={0}
                                                            onMouseEnter={e => {
                                                                const tooltip = e.currentTarget.querySelector('.owner-tooltip');
                                                                tooltip.style.opacity = 1;
                                                                tooltip.style.visibility = 'visible';
                                                            }}
                                                            onMouseLeave={e => {
                                                                const tooltip = e.currentTarget.querySelector('.owner-tooltip');
                                                                tooltip.style.opacity = 0;
                                                                tooltip.style.visibility = 'hidden';
                                                            }}
                                                            onFocus={e => {
                                                                const tooltip = e.currentTarget.querySelector('.owner-tooltip');
                                                                tooltip.style.opacity = 1;
                                                                tooltip.style.visibility = 'visible';
                                                            }}
                                                            onBlur={e => {
                                                                const tooltip = e.currentTarget.querySelector('.owner-tooltip');
                                                                tooltip.style.opacity = 0;
                                                                tooltip.style.visibility = 'hidden';
                                                            }}
                                                        >
                                                            <i className="fas fa-info-circle"></i>
                                                            <div className="tooltip owner-tooltip" style={{ position: 'absolute', top: '100%', left: 0, transform: 'translateY(8px)', opacity: 1, visibility: 'hidden', transition: 'opacity 0.2s', backgroundColor: '#CCC', color: '#000', width: '200px', padding: '8px', borderRadius: '4px', fontSize: '12px', zIndex: 1000 }}>
                                                                Enter the full name of the owner as shown on the Trade License or official company registration document.
                                                            </div>
                                                        </span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="ownerName"
                                                        placeholder="Enter Owner name..."
                                                        value={state?.ownerName}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="login-email" style={{ display: 'flex', alignItems: 'center', gap: 6, position: 'relative' }}>
                                                        Company Name
                                                        <span className="required"> *</span>
                                                        <span
                                                            style={{
                                                                marginLeft: 4,
                                                                color: '#a6a6a6',
                                                                cursor: 'pointer',
                                                                fontSize: 16,
                                                                display: 'inline-flex',
                                                                alignItems: 'center',
                                                                position: 'relative'
                                                            }}
                                                            tabIndex={0}
                                                            onMouseEnter={e => {
                                                                const tooltip = e.currentTarget.querySelector('.company-tooltip');
                                                                tooltip.style.opacity = 1;
                                                                tooltip.style.visibility = 'visible';
                                                            }}
                                                            onMouseLeave={e => {
                                                                const tooltip = e.currentTarget.querySelector('.company-tooltip');
                                                                tooltip.style.opacity = 0;
                                                                tooltip.style.visibility = 'hidden';
                                                            }}
                                                            onFocus={e => {
                                                                const tooltip = e.currentTarget.querySelector('.company-tooltip');
                                                                tooltip.style.opacity = 1;
                                                                tooltip.style.visibility = 'visible';
                                                            }}
                                                            onBlur={e => {
                                                                const tooltip = e.currentTarget.querySelector('.company-tooltip');
                                                                tooltip.style.opacity = 0;
                                                                tooltip.style.visibility = 'hidden';
                                                            }}
                                                        >
                                                            <i className="fas fa-info-circle"></i>
                                                            <div
                                                                className="tooltip company-tooltip"
                                                                style={{
                                                                    position: 'absolute',
                                                                    top: '100%',
                                                                    left: 0,
                                                                    transform: 'translateY(8px)',
                                                                    opacity: 0,
                                                                    visibility: 'hidden',
                                                                    transition: 'opacity 0.2s',
                                                                    backgroundColor: '#CCC',
                                                                    color: '#000',
                                                                    width: '220px',
                                                                    padding: '8px',
                                                                    borderRadius: '4px',
                                                                    fontSize: '12px',
                                                                    zIndex: 1000
                                                                }}
                                                            >
                                                                Enter the exact company name as it appears on your Trade License or official registration documents.
                                                            </div>
                                                        </span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Company name..."
                                                        name="businessName"
                                                        value={state?.businessName}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="login-email">
                                                        Phone Number
                                                        <span className="required"> *</span>
                                                    </label>
                                                    <input
                                                        type="number"
                                                        className="form-control"
                                                        placeholder="Enter Phone Number..."
                                                        name="phoneNumber"
                                                        value={state?.phoneNumber}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="login-email">
                                                        Company Email
                                                        <span className="required"> *</span>
                                                    </label>
                                                    <input
                                                        type="email"
                                                        className="form-control"
                                                        name="email"
                                                        placeholder="Enter Company Email..."
                                                        value={state?.email}
                                                        onChange={handleChange}
                                                        required
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="login-email">
                                                        Company Emirate
                                                        <span className="required"> *</span>
                                                    </label>
                                                    <Select
                                                        options={BusinessCities}
                                                        value={BusinessCities.find(
                                                            (item) => item.value === state.business_city
                                                        ) || null}
                                                        onChange={(selectedOption) => {
                                                            setState({
                                                                ...state,
                                                                business_city: selectedOption ? selectedOption.value : ""
                                                            });
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="login-email">
                                                        Company Area
                                                        <span className="text-muted">(Optional)</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="business_area"
                                                        placeholder="Enter Company area..."
                                                        value={state?.business_area}
                                                        onChange={handleChange}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label htmlFor="login-email">
                                                        Brands Region
                                                        <span className="required"> *</span>
                                                    </label>
                                                    <Select
                                                        placeholder="Select Brand Region..."
                                                        isMulti
                                                        closeMenuOnSelect={false}
                                                        value={BusinessBrandsRegion.filter(item =>
                                                            business_brand_region?.includes(item.value.trim())
                                                        )}
                                                        options={BusinessBrandsRegion}
                                                        onChange={(selectedOptions) => {
                                                            const values = selectedOptions
                                                                ? selectedOptions.map(item => item.value.trim())
                                                                : [];

                                                            setBusinessBrandRegion(values);
                                                        }}
                                                    />
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="form-group">
                                                    <label>
                                                        Business Category <span className="required">*</span>
                                                    </label>
                                                    <div className="d-flex align-items-center" style={{ gap: 24 }}>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="business_type"
                                                                id="storeRadio"
                                                                value="0"
                                                                checked={state.business_type === "0"}
                                                                onChange={handleChange}
                                                            />
                                                            <label className="form-check-label" htmlFor="storeRadio" style={{ fontWeight: 500, color: '#222', paddingLeft: '7px', paddingTop: '7px' }}>
                                                                Spare Part Shop
                                                            </label>
                                                        </div>
                                                        <div className="form-check form-check-inline">
                                                            <input
                                                                className="form-check-input"
                                                                type="radio"
                                                                name="business_type"
                                                                id="garageRadio"
                                                                value="1"
                                                                checked={state.business_type === "1"}
                                                                onChange={handleChange}
                                                            />
                                                            <label className="form-check-label" htmlFor="garageRadio" style={{ fontWeight: 500, color: '#222', paddingLeft: '7px', paddingTop: '7px' }}>
                                                                Garage
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-md-3 d-flex justify-content-center align-items-center">
                                                <button onClick={() => setStep(2)} type='submit' className='login-button py-3'>Next</button>
                                            </div>

                                        </div>
                                    </div>
                                )}

                                {step === 2 && (
                                    <div className="form-step">
                                        <form>
                                            <div>
                                                {/* Document Name */}


                                                {/* File Input with Custom Button */}
                                                {
                                                    documents.length === 0 && (
                                                        <div className="alert alert-info" role="alert" style={{ textAlign: 'center' }}>
                                                            No documents added yet. Please add a document to proceed.
                                                        </div>
                                                    )
                                                }
                                                {/* Uploaded Documents */}
                                                {documents.length > 0 && (
                                                    <div>
                                                        <h5>Upload Documents </h5>

                                                        <table className=" table table-xs table-striped">
                                                            {documents.map((doc, index) => {
                                                                const file = doc.document_path ?? '';
                                                                const isPdf = file.type === 'application/pdf';
                                                                const isImage = file.type ? file.type.startsWith('image/') ?? null : null;

                                                                return (
                                                                    <tr key={index}>
                                                                        <td className="d-flex align-items-center" >

                                                                            <div className="d-flex align-items-center">
                                                                                {isPdf ? (
                                                                                    <FaFileAlt size={24} className="mr-2 text-danger" />
                                                                                ) : isImage ? (
                                                                                    <FaFileAlt size={24} className="mr-2 text-success" />
                                                                                ) : (
                                                                                    <FaFileAlt size={24} className="mr-2 text-secondary" />
                                                                                )}

                                                                                <p className="mb-0" style={{ fontSize: '12px', fontWeight: '600' }}>{doc.document_name}</p>
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <input className='form-control' type='file' onChange={(file) => {
                                                                                const maxSize = 1 * 1024 * 1024; // 1 MB in bytes
                                                                                if (file.target.files[0].size > maxSize) {
                                                                                    // alert using swal
                                                                                    Swal.fire({
                                                                                        icon: 'error',
                                                                                        title: 'File Size',
                                                                                        text: 'File size exceeds 1MB. Please select a smaller file.',
                                                                                    });
                                                                                    file.target.value = ""; // reset the input
                                                                                    return;
                                                                                }
                                                                                var documentsx = documents
                                                                                documentsx[index].document_path = file.target.files[0];
                                                                                // documentsx[index].document_name = file.target.files[0].name;
                                                                                setDocuments([...documentsx]);
                                                                                // Handle file upload
                                                                            }} />
                                                                        </td>


                                                                    </tr>
                                                                );
                                                            })}

                                                        </table>
                                                    </div>
                                                )}

                                                {/* Submit and Back Buttons */}
                                                <div className="row" style={{ marginTop: "-50px", marginBottom: "0px" }}>
                                                    <div className="col-md-9"></div>
                                                    <div className="col-md-3">
                                                        <div className="d-flex justify-content-end align-items-center gap-2">
                                                            <button
                                                                type="button"
                                                                className="btn btn-dark  py-3"
                                                                onClick={() => setStep(1)}
                                                                style={{ minWidth: '100px' }}
                                                            >
                                                                Back
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary py-3 ml-2"
                                                                disabled={documents.length === 0}
                                                                onClick={handleSubmit}
                                                                style={{ minWidth: '100px' }}
                                                            >
                                                                Submit
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                )}

                                <div className="text-center">
                                    <p style={{ color: '#666' }}>
                                        Already have an account?{' '}
                                        <NavLink
                                            to="/login"
                                            style={{
                                                color: '#0d6efd',
                                                textDecoration: 'none',
                                                fontWeight: '500'
                                            }}
                                        >
                                            Back to Login
                                        </NavLink>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};

export default Registration;